import React from "react";
import { Check, X } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { BEFORE, AFTER } from "@/data/content";

export const BeforeAfterSection = () => {
  return (
    <section id="before-after" data-testid="before-after-section" className="relative py-20 sm:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="The difference" title="Before Workpay. After Workpay." center />
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal delay={0.05}>
            <div data-testid="before-card" className="h-full rounded-3xl border border-slate-200 bg-slate-50 p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-10 w-10 rounded-xl bg-red-100 flex items-center justify-center">
                  <X className="h-5 w-5 text-red-500" />
                </div>
                <h3 className="font-display text-xl font-bold text-slate-700">Before Workpay</h3>
              </div>
              <ul className="space-y-3.5">
                {BEFORE.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[15px] text-slate-500">
                    <X className="h-4 w-4 text-red-400 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div data-testid="after-card" className="h-full rounded-3xl border-2 border-[#21c55e]/30 bg-white p-8 soft-shadow">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-10 w-10 rounded-xl bg-[#ecfdf3] flex items-center justify-center">
                  <Check className="h-5 w-5 text-[#16a34a]" />
                </div>
                <h3 className="font-display text-xl font-bold text-[#091630]">After Workpay</h3>
              </div>
              <ul className="space-y-3.5">
                {AFTER.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[15px] text-[#091630] font-medium">
                    <span className="h-5 w-5 rounded-full bg-[#ecfdf3] flex items-center justify-center shrink-0">
                      <Check className="h-3 w-3 text-[#16a34a]" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 text-center font-display text-xl sm:text-2xl font-bold text-[#091630] max-w-3xl mx-auto">
            Normal payment links collect money. Workpay manages the{" "}
            <span className="text-gradient">trust around the project.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
